import { Injectable } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { Nullable } from '@frontend/sports/common/core/utils/extended-types';
import { ConfirmationDialogButtonType, ConfirmationDialogService, ModalRef } from '@frontend/sports/modal/feature';
import { TrackingType, trackingConstants } from '@frontend/sports/tracking/feature';
import { EpcotConfigService, EpcotModule } from 'packages/sports/web/app/src/common/epcot-config.service';

@Injectable()
export class EditBetExitConfirmationDialogService {
    private ref: Nullable<ModalRef> = null;
    private epcotEnabled: boolean;
    constructor(
        private confirmationDialog: ConfirmationDialogService,
        private siteCore: Sitecore,
        private epcotConfigService: EpcotConfigService,
    ) {
        this.epcotEnabled = this.epcotConfigService.isEnabled(EpcotModule.Betslip);
    }

    async show(): Promise<ConfirmationDialogButtonType | undefined> {
        if (this.ref === null) {
            const epcotClass = this.epcotEnabled ? 'epcot-enabled' : '';
            this.ref = this.confirmationDialog.showDialog({
                title: this.siteCore.betslip.editBet.confirmExitTitle,
                message: this.siteCore.betslip.editBet.confirmExitMessage,
                buttons: [
                    {
                        buttonType: ConfirmationDialogButtonType.Cancel,
                        buttonTitle: this.siteCore.betslip.editBet.confirmExitYes,
                        buttonConfig: {
                            kind: this.epcotEnabled ? 'secondary' : 'tertiary',
                            variant: 'outline',
                            size: 'large',
                        },
                    },
                    {
                        buttonType: ConfirmationDialogButtonType.Ok,
                        buttonTitle: this.siteCore.betslip.editBet.confirmExitNo,
                        buttonConfig: {
                            kind: 'primary',
                            variant: 'filled',
                            size: 'large',
                        },
                    },
                ],
                tracking: {
                    name: trackingConstants.EVENT_EDIT_BET,
                    data: {
                        [trackingConstants.PAGE_REFERRING_ACTION]: 'Sports_EditBet_EditBetExit_Screen_Loaded',
                        [trackingConstants.PAGE_SITE_SECTION]: 'myBets',
                    },
                    type: TrackingType.PageName,
                },
                backdropClass: 'edit-exit-confirmation-dialog-backdrop',
                cssClass: `edit-exit-confirmation-dialog-window ${epcotClass}`,
            });

            // Catch closing dialog using backdrop click
            return await this.ref.result.catch(() => {}).finally(() => (this.ref = null));
        }

        return undefined;
    }
}
